// Mirror of TEST_REDIRECT_PATH on the server. Kept in sync by hand —
// the server registers `${ISSUER_BASE_URL}${TEST_REDIRECT_PATH}` as a
// default redirect URI on every new app; the client constructs the same
// URL from `window.location.origin` to drive the test sign-in button.
export const TEST_REDIRECT_PATH = "/test-callback";

export function getTestRedirectUri(): string {
  return `${window.location.origin}${TEST_REDIRECT_PATH}`;
}

export function isTestRedirectUri(uri: string): boolean {
  try {
    return new URL(uri).pathname === TEST_REDIRECT_PATH;
  } catch {
    return false;
  }
}

export function buildTestStateValue(appId: string): string {
  return `test:${appId}`;
}
